export default __webpack_public_path__ + "static/media/photo--sm--26.9cd80a4d.jpg";